import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _EmployeeBonus, _EmployeeIncapacity, _EmployeeNovelty } from '../../../../../core/services/dataBean/EntityCatalog';
import { et } from 'date-fns/locale';
import { toast } from 'react-toastify';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectElectronicPayrollIncapacitiesYears = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_EmployeeIncapacity)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
    }, [])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {
        instance.getElectronicPayrollIncapacitiesYears(null).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(err => { toast.error(err) });
    }


    return (
        <>
            <label>{label ?? "Año a Aplicar"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null
                setValue(valor)
            }}>
                <option value={""} >...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}